export const countriesPath = '/countries';

export const initialState = {
    name: '',
    countryCode: '',
    alpha2: '',
    alpha3: '',
    nationalCodes: [],
    multiNationalCodes: [],
};

export const breadCrumbTrail = [
    { label: 'Admin', path: '' },
    { label: 'Countries', path: countriesPath },
    { label: 'Add Country', path: '' },
];

export const breadCrumbTrailEdit = [
    { label: 'Admin', path: '' },
    { label: 'Countries', path: countriesPath },
    { label: 'Edit Country', path: '' },
];

export const addHeader = 'Country Details';
export const editHeader = 'Edit Country Details';

export const codesInfoText =
    'National and Multi-National codes are ONLY used when a Country Code is shared across multiple countries.';
export const NUMERIC_PATTERN = /^\d+$/;
export const focusWithinStyles = {
    zIndex: 1,
    borderColor: 'var(--chakra-colors-brand-500)',
    boxShadow: '0 0 0 1px var(--chakra-colors-brand-500)',
};
// FieldError's pl target, in px, verified against the rendered layout: label width (246) + FormLabel's default marginEnd (12) + stack spacing.
export const LABEL_TO_INPUT_GAP = 333;
